import { createInstance } from "i18next";
import type { i18n as i18nType } from "i18next";
import FetchBackend from "i18next-fetch-backend";
import { initReactI18next } from "react-i18next";

import { environment } from "../environment";
import { joinPath } from "../utils/joinPath";
import { DEFAULT_LOCALE } from "./constants";

// @ts-ignore imported by rollup plugin
import code from "message-bundle";

type KeyValue = { key: string; value: string };

export const KEY_SEPARATOR = ".";

export const i18n: i18nType = createInstance({
  fallbackLng: DEFAULT_LOCALE,
  keySeparator: KEY_SEPARATOR,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
  defaultNS: [environment.realm],
  ns: [environment.realm],
  backend: {
    loadPath: joinPath(
      environment.adminBaseUrl,
      `resources/{{ns}}/admin/{{lng}}`,
    ),
    parse: (data: string, url?: string) => {
      const messages: KeyValue[] = JSON.parse(data);
      const parsed = Object.fromEntries(
        messages.map(({ key, value }) => [key, value]),
      );
      if (import.meta.env.VITE_REALM_OVERRIDES === undefined) {
        // fork 自有键（umPerm*、umUserFullName 等）只随前端仓库走，KC 服务器主题包
        // （base 镜像 dist）里没有这些键——此前仅 dev 注入本地 bundle，生产表头会
        // 显示原始键（如用户列表 umUserFullName）。现改为全环境叠加：按请求语言
        // 叠加到服务器返回之上（覆盖同名、补缺键）。VITE_REALM_OVERRIDES=true
        // 仍可关闭叠加以查看 realm 级覆盖。loadPath 末段即请求的 {{lng}}。
        const lng = url?.split("/").pop() ?? "en";
        const bundles = code as Record<string, Record<string, string>>;
        return { ...parsed, ...(bundles[lng.startsWith("zh") ? "zh-Hans" : lng] ?? {}) };
      }
      return parsed;
    },
  },
});

i18n.use(FetchBackend);
i18n.use(initReactI18next);
